import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { CriteoPageType, CriteoSiteType, EventType, EventCategory, EventAction, EventLabel } from "./types";
/**
 * Push data to the data layer
 * https://developers.google.com/tag-platform/tag-manager/web/datalayer
 */ var trackEvent = function() {
    var _ref = _async_to_generator(function(data) {
        return _ts_generator(this, function(_state) {
            if ("object" === "undefined") return [
                2
            ];
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(data);
            return [
                2
            ];
        });
    });
    return function trackEvent(data) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * PageView events
 */ var trackPageView = function(data) {
    if (!data) {
        return;
    }
    trackEvent(_object_spread({
        event: EventType.PAGE_VIEW
    }, data));
};
/**
 * Custom events
 * https://silvertours.atlassian.net/wiki/spaces/PAGES/pages/2369650717/Tracking+events+on+the+landing+pages#Current-events
 */ // Account menu opened
var trackShowLogin = function(param) {
    var _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.INDEX,
        eventAction: EventAction.LOGIN_MENU,
        eventLabel: isLoggedIn ? EventLabel.LOGGED : EventLabel.UNLOGGED
    });
};
// Landing page loaded | Criteo event
var trackCriteo = function() {
    trackEvent({
        event: EventType.CUSTOM_CRITEO,
        criteo_tag_params: {
            CriteoPageType: CriteoPageType.Homepage,
            CriteoSiteType: CriteoSiteType.desktop
        }
    });
};
// Login form submitted
var trackLogin = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_MENU_LOGIN,
        eventLabel: EventLabel.LOGGED
    });
};
// "Password forgotten" link clicked
var trackPasswordForgotten = function(param) {
    var _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_MENU_FORGOTPWD,
        eventLabel: isLoggedIn ? EventLabel.LOGGED : EventLabel.UNLOGGED
    });
};
// "Register new user" link clicked
var trackNewUser = function(param) {
    var _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_MENU_CREATE_ACCOUNT,
        eventLabel: isLoggedIn ? EventLabel.LOGGED : EventLabel.UNLOGGED
    });
};
// Logout
var trackLogout = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_LOGOUT,
        eventLabel: EventLabel.UNLOGGED
    });
};
// "My bookings" link clicked
var trackMyBookings = function(param) {
    var _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_MENU_MYBOOKINGS,
        eventLabel: isLoggedIn ? EventLabel.LOGGED : EventLabel.UNLOGGED
    });
};
// "My data“" link clicked
var trackMyData = function(param) {
    var _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_MENU_MYDATA,
        eventLabel: isLoggedIn ? EventLabel.LOGGED : EventLabel.UNLOGGED
    });
};
// "My payment data" link clicked
var trackMyPayment = function(param) {
    var _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_MENU_MYPAYMENT,
        eventLabel: isLoggedIn ? EventLabel.LOGGED : EventLabel.UNLOGGED
    });
};
// "Get voucher" button clicked
var trackVoucherButtonClick = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ALL,
        eventAction: EventAction.CLICK_PHONE_TOOLTIP_VOUCHER_LINK,
        eventLabel: true
    });
};
// Opening times tooltip opened (via hover)
var trackOpeningTimesTooltipOpened = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.TOOLTIP,
        eventAction: EventAction.HOVER,
        eventLabel: "callcenter"
    });
};
// Newsletter form submitted on index page
var trackNewsletterRegistrationIndex = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.INDEX,
        eventAction: EventAction.CLICK,
        eventLabel: "click_NewsletterSigninBoxEbook"
    });
};
// Newsletter form submitted anywhere else
var trackNewsletterRegistration = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.NEWSLETTER_REGISTRATION,
        eventAction: EventAction.CLICK,
        eventLabel: "submit"
    });
};
// "More options" in search form clicked
var trackToggleMoreOptions = function(showOptions) {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.INDEX,
        eventAction: EventAction.SEARCHFORM_MORE_OPTIONS,
        eventLabel: showOptions ? EventLabel.OPEN : EventLabel.CLOSED
    });
};
// Filter in search form clicked
var trackOptionsChange = function(id) {
    if (!id) {
        return;
    }
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.INDEX,
        eventAction: EventAction.SEARCHFORM_MORE_OPTIONS_FILTER_CLICK,
        eventLabel: id
    });
};
// Selecting an item from the search history
var trackSearchHistorySelect = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.SEARCH_HISTORY,
        eventAction: EventAction.CLICK,
        eventLabel: "history_item"
    });
};
// Deleting an item from the search history
var trackSearchHistoryDelete = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.SEARCH_HISTORY,
        eventAction: EventAction.CLICK,
        eventLabel: "delete_history"
    });
};
// Opening times tooltip footer opened (via hover)
var trackFooterTooltipOpened = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.TOOLTIP,
        eventAction: EventAction.HOVER,
        eventLabel: "callcenter_footer"
    });
};
// Main navigation list item clicked
var trackNavigationClicked = function(name) {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.NAVIGATION,
        eventAction: EventAction.CLICK,
        eventLabel: name
    });
};
// Hover on free cancellation badge
var trackCancellationHover = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.TOOLTIP,
        eventAction: EventAction.HOVER,
        eventLabel: "cancellation_stage"
    });
};
var trackSavingHover = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.TOOLTIP,
        eventAction: EventAction.HOVER,
        eventLabel: "saving_stage"
    });
};
// Info Banner link clicked
var trackInfoBannerLinkClicked = function(label) {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.INFO_BANNER,
        eventAction: EventAction.CLICK,
        eventLabel: "info_banner_".concat(label)
    });
};
var trackInfoBannerCloseClicked = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.INFO_BANNER,
        eventAction: EventAction.CLICK,
        eventLabel: "info_banner_close"
    });
};
// Hover on driver age
var trackDriverAgeHover = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.TOOLTIP,
        eventAction: EventAction.HOVER,
        eventLabel: "driver_age"
    });
};
// Change roundtrip to oneway dropdown
var trackRoundtripOneway = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ROUNDTRIP,
        eventAction: EventAction.ONEWAY_SELECT,
        eventLabel: ""
    });
};
// Change driver age dropdown from default age
var trackDriverAgeSelect = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.DRIVERAGE,
        eventAction: EventAction.SELECT,
        eventLabel: ""
    });
};
// Confienza clicked (just Floyt)
var trackConfienzaClicked = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.CONFIENZA,
        eventAction: EventAction.CLICK,
        eventLabel: "confienza_stage"
    });
};
// FAQ list item clicked (open expandable)
var trackFaqItemClicked = function(pagepath) {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.FAQ,
        eventAction: EventAction.CLICK,
        eventLabel: pagepath
    });
};
// Button to Helpcenter is clicked
var trackHelpcenterButtonClicked = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.FAQ,
        eventAction: EventAction.CLICK,
        eventLabel: "zendesk_button"
    });
};
// Button search in offer boxes clicked
var trackSearchButtonOfferBoxClicked = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.SEARCH_BUTTON_OFFERBOX,
        eventAction: EventAction.CLICK,
        eventLabel: ""
    });
};
// Customer review read more clicked
var trackCustomerReviewClicked = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.CUSTOMER_REVIEW,
        eventAction: EventAction.CLICK,
        eventLabel: ""
    });
};
// iOS App link clicked
var trackIosAppLinkClicked = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.APP_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "landingpage_promo_banner_appstore_tap"
    });
};
// iOS App link footer clicked
var trackIosAppLinkFooterClicked = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.APP_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "iOS_download_footer"
    });
};
// Android App link clicked
var trackAndroidAppLinkClicked = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.APP_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "landingpage_promo_banner_playstore_tap"
    });
};
// Android App footer link clicked
var trackAndroidAppLinkFooterClicked = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.APP_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "ANDROID_download_footer"
    });
};
// Facebook footer link clicked
var trackFacebookFooterClicked = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.SOCIAL_MEDIA_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "FB_footer"
    });
};
// Instagram footer link clicked
var trackInstagramFooterClicked = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.SOCIAL_MEDIA_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "insta_footer"
    });
};
// Pinterest footer link clicked
var trackPinterestFooterClicked = function() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.SOCIAL_MEDIA_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "PIN_footer"
    });
};
// All other footer links clicked
var trackFooterClicked = function(name) {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.GENERAL_FOOTER_LINKS,
        eventAction: EventAction.CLICK,
        eventLabel: name
    });
};
var trackStationMapStationClick = function(stationKind) {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.STATIONS_MAP,
        eventAction: EventAction.CLICK,
        eventLabel: "station_type_".concat(stationKind)
    });
};
function isINPMetric(metric) {
    return metric.name === "INP";
}
var trackWebVitalsMetric = function(metric) {
    var name = metric.name, delta = metric.delta, id = metric.id;
    var eventPayload = {
        event: EventType.GA,
        eventCategory: EventCategory.WEB_VITALS,
        eventAction: name,
        // The `id` value will be unique to the current page load. When sending
        // multiple values from the same page (e.g. for CLS), Google Analytics can
        // compute a total by grouping on this ID (note: requires `eventLabel` to
        // be a dimension in your report).
        eventLabel: id,
        // Google Analytics metrics must be integers, so the value is rounded.
        // For CLS the value is first multiplied by 1000 for greater precision
        // (note: increase the multiplier for greater precision if needed).
        eventValue: Math.round(name === "CLS" ? delta * 1000 : delta),
        // Use a non-interaction event to avoid affecting bounce rate.
        nonInteraction: true,
        // Use `sendBeacon()` if the browser supports it.
        transport: "beacon"
    };
    if (isINPMetric(metric)) {
        var attribution = metric.attribution;
        // Element that is interacted with.
        eventPayload.eventTarget = attribution.eventTarget;
        // Type of interaction with the element.
        eventPayload.eventType = attribution.eventType;
    }
    trackEvent(eventPayload);
};
export { trackEvent, trackCriteo, trackPageView, trackShowLogin, trackLogin, trackPasswordForgotten, trackNewUser, trackLogout, trackMyBookings, trackMyPayment, trackMyData, trackVoucherButtonClick, trackOpeningTimesTooltipOpened, trackNewsletterRegistrationIndex, trackNewsletterRegistration, trackToggleMoreOptions, trackOptionsChange, trackSearchHistorySelect, trackSearchHistoryDelete, trackFooterTooltipOpened, trackNavigationClicked, trackCancellationHover, trackSavingHover, trackInfoBannerLinkClicked, trackInfoBannerCloseClicked, trackDriverAgeHover, trackRoundtripOneway, trackDriverAgeSelect, trackConfienzaClicked, trackFaqItemClicked, trackHelpcenterButtonClicked, trackSearchButtonOfferBoxClicked, trackCustomerReviewClicked, trackIosAppLinkClicked, trackIosAppLinkFooterClicked, trackAndroidAppLinkClicked, trackAndroidAppLinkFooterClicked, trackFacebookFooterClicked, trackInstagramFooterClicked, trackPinterestFooterClicked, trackFooterClicked, trackWebVitalsMetric, trackStationMapStationClick };
